/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $LeagueMatchImportRequest_Input = {
    properties: {
        matchDay: {
            type: 'number',
            isRequired: true,
        },
        team1: {
            type: 'LeagueMatchTeamImport',
            isRequired: true,
        },
        team2: {
            type: 'LeagueMatchTeamImport',
            isRequired: true,
        },
        league: {
            type: 'LeagueMatchLeagueImport',
            isRequired: true,
        },
        startTime: {
            type: 'string',
            isRequired: true,
            format: 'date-time',
        },
    },
} as const;
